import { render, staticRenderFns } from "./CreditiImpostaListTable.vue?vue&type=template&id=23fddfb5&"
import script from "./CreditiImpostaListTable.vue?vue&type=script&lang=js&"
export * from "./CreditiImpostaListTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports